import React from "react";
import Select from "react-select";

const ReactSelect = props => {
  return (
    <div className="select-box">
      <Select
        options={props.options}
        value={props.value}
        defaultValue={props.defaultValue}
        placeholder={props.placeholder}
        isClearable={props.isClearable}
        isMulti={props.isMulti}
        closeMenuOnSelect={props.closeMenuOnSelect}
        isDisabled={props.isDisabled}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onChange={props.onChange}
        isSearchable={props.isSearchable}
      />
    </div>
  );
};

export default ReactSelect;
